export enum LiquidityBufferAppEnum {
  APP_REPRESENTATIVE = 'APP_REPRESENTATIVE',
  APP_SELLER = 'APP_SELLER',
  APP_SHOPKEEPER = 'APP_SHOPKEEPER',
}
